import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			projectsTakeawaysInfoCls: string;
			projectsTakeawaysBoxItemCls: string;
			projectsDetailsTakeawaysHeaderCls: string;
		}
	},

	slug: string
}

class Takeaways extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Projects Details Takeaways Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();

		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsDetailsTakeawaysHeaderCls || '', 'projects_takeaways', { animCls: 'animate__flipInX', once: true});

		if(this.publicVars.cssId.anim?.projectsTakeawaysInfoCls) {
			const infoCount = document.querySelectorAll(this.publicVars.cssId.anim?.projectsTakeawaysInfoCls).length;

			if(infoCount) {
				scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsTakeawaysInfoCls || '', 'projects_takeaways', { animCls: 'animate__fadeIn', once: true});
			}
		}

		if(this.publicVars.cssId.anim?.projectsTakeawaysBoxItemCls) {
			const takeawaysCount = document.querySelectorAll(this.publicVars.cssId.anim?.projectsTakeawaysBoxItemCls).length;

			for(let i = 1; i<= takeawaysCount; i++) {
				scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsTakeawaysBoxItemCls + i, 'projects_takeaways', { animCls: 'animate__zoomIn50P', once: true});
			}
		}
	}

	bind() {
		this.msg('bind');
	}
}

export default Takeaways;